import { render, staticRenderFns } from "./tradingproduct.vue?vue&type=template&id=3f54b376&scoped=true"
import script from "./tradingproduct.vue?vue&type=script&lang=js"
export * from "./tradingproduct.vue?vue&type=script&lang=js"
import style0 from "./tradingproduct.vue?vue&type=style&index=0&id=3f54b376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54b376",
  null
  
)

export default component.exports